// extracted by mini-css-extract-plugin
export default {"disclaimer":"Disclaimer_disclaimer__+cW1S","disclaimer__title":"Disclaimer_disclaimer__title__yOK5k","disclaimer__content":"Disclaimer_disclaimer__content__0B4rz"};